import type { MouseEvent } from "react";

export const stopPropagation = (func?: (e: MouseEvent<Element>) => void) => (e: MouseEvent<Element>) => {
    e.stopPropagation();
    func?.(e);
};
